<template>
  <div>
    <div class="container">
        <p class="photo-box">“To me, photography is an art of observation. It’s about finding something interesting in an ordinary place… I’ve found it has little to do with the things you see and everything to do with the way you see them.” — Elliott Erwitt</p>
    </div>
    <div class="container grid">
        <div class="photo-grid" v-for="item in items" :key="item.id" @click="goToPhotoDetail(item)">
            <img class="photo-image" :src="item.content.thumb" alt="photo">
            <h6> {{item.name}} </h6>
        </div>
    </div>
  </div>
</template>



<script>
const StoryblokClient = require('storyblok-js-client');
const Storyblok = new StoryblokClient({
  accessToken: process.env.VUE_APP_KEY,
  cache: {
    clear: 'auto',
    type: 'memory'
  }
});
export default {
    name: 'photography',
    methods: {
        getStories() {
            Storyblok.get('cdn/stories', {
                "starts_with": "portfolio/photos/"
            })
            .then(response => {
                this.items = response.data.stories;
            }).catch(error => { 
                console.log(error)
            })
        },
        goToPhotoDetail(item) {
            this.$router.push({
              name: 'photo-details',
              params: {
                  full_slug: item.full_slug,
              }
            })
        }
    },
    data: function () {
        return {
            items: [],
        }
    },
    mounted() {
        this.getStories();
    }
}
</script>



<style>
.photo-box {
    position: relative;
    display: inline-block;
    width: 50%;
    padding: 100px 0;
}
.photo-grid {
    position: relative;
    display: inline-block;
    width: 33%;
    margin-bottom: 50px;
}
.photo-image {
    width: 280px;
    padding-bottom: 30px;
    border-radius: 5px;
}
img:hover {
    cursor: pointer;
}
h6:hover {
    color: #F3A822 ;
    transition: all 0.5s ease-in;
    cursor: pointer;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.photo-box {
  width: 65%;
  padding: 50px 0 40px;
}
.photo-grid{
  width: 75%;
  margin: 25px 0 50px;
}
.photo-grid h6 {
  color: #F3A822 ;
}
.photo-image {
  width: 90%;
  padding: 15px 0 10px;
  border-radius: 5px;
}
}
@media only screen and (max-width: 600px) {
.photo-box {
  width: 75%;
  padding: 50px 0 40px;
}
.photo-grid{
  width: 75%;
  margin: 25px 0 50px;
}
.photo-grid h6 {
  color: #F3A822 ;
}
.photo-image {
  width: 90%;
  padding: 15px 0 10px;
  border-radius: 5px;
}
}
</style>